import { configureStore } from "@reduxjs/toolkit";
import { clinicTrainingApi } from "./Clinictrainingapi";
import { authApi } from "./auth";

export const store = configureStore({
  reducer: {
    [clinicTrainingApi.reducerPath]: clinicTrainingApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(clinicTrainingApi.middleware)
      .concat(authApi.middleware),
});